var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e0afb2fb30a1422a3558bbea78c6f94f1656d854"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-staging@xyte-0n"]={id:"e0afb2fb30a1422a3558bbea78c6f94f1656d854"};
      